import { Union } from 'ts-toolbelt';

export interface LocationSearchParams {
  q?: string;
  e?: string;
  hideQb?: Union.Nullable<boolean>;
}

export const preserveLocationSearchParams: string[] = ['hideQb'];
